// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__bC5oq","cellSelected":"styles_cellSelected__2ub1o","celltrue":"styles_celltrue__2Nnlc","cellfalse":"styles_cellfalse__3Is5x"};